import { render, staticRenderFns } from "./RelacionesUsuario.vue?vue&type=template&id=7ecc0dfc"
import script from "./RelacionesUsuario.vue?vue&type=script&lang=js"
export * from "./RelacionesUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports